import React, { useState, useEffect } from "react";
import { collection, getDocs, query, where, doc, updateDoc, writeBatch } from "firebase/firestore";
import { db } from "../../../firebaseConfig";

const FuelApproval = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    fetchPendingTransactions();
  }, []);

  // 1. Pending (Onay Bekleyen) Kayıtları Getir
  const fetchPendingTransactions = async () => {
    setLoading(true);
    try {
      const q = query(
        collection(db, "fuel_transactions"),
        where("status", "==", "pending")
      );
      const querySnapshot = await getDocs(q);
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setTransactions(data);
    } catch (error) {
      console.error("Veri çekme hatası:", error);
      alert("Veriler alınırken bir hata oluştu.");
    }
    setLoading(false);
  };

  // 2. Seçim İşlemleri
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(transactions.map((t) => t.id));
    } else {
      setSelectedIds([]);
    }
  };

  const handleSelectOne = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  // 3. Toplu Onaylama (Approved Yapma)
  const handleApproveSelected = async () => {
    if (selectedIds.length === 0) return alert("Lütfen önce işlem seçin!");
    
    const confirmApprove = window.confirm(`${selectedIds.length} adet işlemi onaylamak istediğinize emin misiniz?`);
    if (!confirmApprove) return;

    setProcessing(true);
    try {
      const batch = writeBatch(db); // Daha hızlı ve güvenli toplu işlem için Batch kullanıyoruz

      selectedIds.forEach((id) => {
        const docRef = doc(db, "fuel_transactions", id);
        batch.update(docRef, { status: "approved" });
      });

      await batch.commit();
      
      alert("Seçili işlemler başarıyla onaylandı.");
      setSelectedIds([]);
      fetchPendingTransactions(); // Listeyi tazele
    } catch (error) {
      console.error("Güncelleme hatası:", error);
      alert("İşlemler onaylanırken bir hata oluştu.");
    }
    setProcessing(false);
  };

  return (
    <div style={{ padding: 30, background: "#f8fafc", minHeight: "100vh", fontFamily: "sans-serif" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h2 style={{ color: "#1e293b" }}>⛽ Yakıt Onay Ekranı (Pending)</h2>
        <button
          onClick={handleApproveSelected}
          disabled={processing || selectedIds.length === 0}
          style={{
            background: selectedIds.length > 0 ? "#059669" : "#cbd5e1",
            color: "white",
            padding: "12px 25px",
            borderRadius: 8,
            border: "none",
            fontWeight: "bold",
            cursor: selectedIds.length > 0 ? "pointer" : "not-allowed",
          }}
        >
          {processing ? "İşleniyor..." : `Seçilenleri Onayla (${selectedIds.length})`}
        </button>
      </div>

      <div style={{ background: "white", borderRadius: 12, boxShadow: "0 4px 6px rgba(0,0,0,0.05)", overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
          <thead style={{ background: "#f1f5f9" }}>
            <tr>
              <th style={{ padding: 15 }}>
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={selectedIds.length === transactions.length && transactions.length > 0}
                />
              </th>
              <th style={{ padding: 15, fontSize: 13 }}>Tarih</th>
              <th style={{ padding: 15, fontSize: 13 }}>Plaka</th>
              <th style={{ padding: 15, fontSize: 13 }}>Miktar (Litre)</th>
              <th style={{ padding: 15, fontSize: 13 }}>Sürücü</th>
              <th style={{ padding: 15, fontSize: 13 }}>Tesis</th>
              <th style={{ padding: 15, fontSize: 13 }}>Durum</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="7" style={{ padding: 20, textAlign: "center" }}>Yükleniyor...</td></tr>
            ) : transactions.length === 0 ? (
              <tr><td colSpan="7" style={{ padding: 20, textAlign: "center" }}>Onay bekleyen işlem bulunamadı.</td></tr>
            ) : (
              transactions.map((t) => (
                <tr key={t.id} style={{ borderBottom: "1px solid #f1f5f9" }}>
                  <td style={{ padding: 15 }}>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(t.id)}
                      onChange={() => handleSelectOne(t.id)}
                    />
                  </td>
                  <td style={{ padding: 15, fontSize: 13 }}>{t.tarih?.toDate ? t.tarih.toDate().toLocaleDateString() : t.tarih}</td>
                  <td style={{ padding: 15, fontSize: 13, fontWeight: "bold" }}>{t.plaka}</td>
                  <td style={{ padding: 15, fontSize: 13 }}>{t.miktar || t.quantity} L</td>
                  <td style={{ padding: 15, fontSize: 13 }}>{t.soforAdi || t.driverName}</td>
                  <td style={{ padding: 15, fontSize: 13 }}>{t.tesis || "Merkez"}</td>
                  <td style={{ padding: 15 }}>
                    <span style={{ background: "#fef3c7", color: "#92400e", padding: "4px 8px", borderRadius: 6, fontSize: 11, fontWeight: "bold" }}>
                      PENDING
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FuelApproval;